import React, { Fragment } from 'react';
import { get } from 'lodash-es';
// Utils
import { getPriceChange } from 'site-modules/shared/utils/inventory/price-change';
import { isCarMax, isEchoParkAutomotive, isHerbChambers } from 'site-modules/shared/utils/dealer-details-utils';
// Models
import { InventoryEntities } from 'client/data/models/inventory';
// Components
import { PriceSummaryPill } from 'site-modules/inventory/components/price-summary-pill/price-summary-pill';
import { DATA_PATH } from 'client/engagement-handlers/inventory-engagement-handler/constants';
import { PriceDropGraph } from 'site-modules/shared/components/inventory/price-drop-graph/price-drop-graph';

export function PriceSummaryBannerGraph({ vinData = {} }) {
  const { currentPrice, history, originalPrice } = getPriceChange({ vinData });
  const daysToSell = get(vinData, 'computedDisplayInfo.estimatedDaysToSell');
  const firstPublishedDate = get(vinData, 'firstPublishedDate', 0);
  const averagePrice = get(vinData, 'computedDisplayInfo.priceValidation.listPriceEstimate', 0);
  const dealType = get(vinData, 'computedDisplayInfo.priceValidation.dealType', null);

  const parentDealershipName = get(vinData, DATA_PATH.PARENT_DEALERSHIP_NAME, '');
  const isCarMaxDealer = isCarMax(parentDealershipName);
  const isEchoParkAutomotiveDealer = isEchoParkAutomotive(parentDealershipName);
  const isHerbChambersDealer = isHerbChambers(parentDealershipName);

  return (
    <Fragment>
      <PriceSummaryPill
        originalPrice={originalPrice}
        daysToSell={daysToSell}
        isCarMaxDealer={isCarMaxDealer}
        isEchoParkAutomotiveDealer={isEchoParkAutomotiveDealer}
        isHerbChambersDealer={isHerbChambersDealer}
      />
      <PriceDropGraph
        currentPrice={currentPrice}
        history={history}
        margin={{
          top: 5,
          right: 10,
          left: -10,
          bottom: 5,
        }}
        firstPublishedDate={firstPublishedDate}
        wrapperClasses="p-0"
        averagePrice={averagePrice}
        dealType={dealType}
      />
    </Fragment>
  );
}

PriceSummaryBannerGraph.propTypes = {
  vinData: InventoryEntities.InventoryVin,
};
